import {
  Accessibility,
  Cached,
  FormatColorFill,
  HighlightAlt,
  Tonality,
} from "@mui/icons-material";
import { Box, Container, Grid, Typography, useTheme } from "@mui/material";
import React from "react";

const FEATURES = [
  {
    icon: <Cached color="primary" fontSize="large" />,
    title: "AI Tattoo Generator",
    description:
      "Generate tattoos from text in seconds. Choose the output by specifying style, shape, detail & complexity, and more.",
    image: "/images/features/feature_ai_image_generator.webp",
    imageAlt: "AI Tattoo Generator",
  },
  {
    icon: <Accessibility color="primary" fontSize="large" />,
    title: "Templates by Placement",
    description:
      "Specify output based on aspect ratio, custom shape, and even body part. This includes full sleeves!",
    image: "/images/features/feature_placement.webp",
    imageAlt: "Templates by Placement",
  },
  {
    icon: <Tonality color="primary" fontSize="large" />,
    title: "Detail & Complexity",
    description:
      "Adjust the detail of the generated output by choosing how complex it should be. Choose from simple, medium, and complex.",
    image: "/images/features/feature_complexity.webp",
    imageAlt: "Detail & Complexity",
  },
  {
    icon: <HighlightAlt color="primary" fontSize="large" />,
    title: "Stencil Converter",
    description:
      "Upload your own tattoo design and convert it to a stencil. Your initial upload remains private. Download or remix and get 100s of variations of your design!",
    image: "/images/features/feature_stencil.webp",
    imageAlt: "Stencil Converter",
  },
  {
    icon: <FormatColorFill color="primary" fontSize="large" />,
    title: "Coverup & Filler",
    description:
      "Create custom filler tattoos to seamlessly fill gaps and enhance existing ink with AI. Choose a theme, draw the silhouette of the gap, and watch the ideas pour in!",
    image: "/images/features/feature_coverup_filler.webp",
    imageAlt: "Coverup & Filler",
  },
];

export default function HomeFeaturesSection() {
  const theme = useTheme();

  return (
    <Container sx={{ padding: `0 ${theme.spacing(3)}px` }}>
      <Typography variant="h2">Features</Typography>
      <Typography variant="h5" variantMapping={{ h5: "h3" }} sx={{ marginBottom: 4 }}>
        The BlackInk AI tattoo design app simplifies your tattoo design process from
        beginning to end.
      </Typography>

      <Grid container spacing={4}>
        {FEATURES.map((feature, idx) => (
          <React.Fragment key={feature.title}>
            <Grid
              item
              xs={12}
              md={idx % 2 === 0 ? 7 : 5}
              order={{ xs: idx * 2 + (idx % 2 === 0 ? 1 : 0), md: idx }}
            >
              {idx % 2 === 0 ? (
                <img src={feature.image} width="100%" alt={feature.imageAlt} />
              ) : (
                <Box>
                  {feature.icon}
                  <Typography variant="h3" color="inherit">
                    {feature.title}
                  </Typography>
                  <Typography variant="body1" color="inherit">
                    {feature.description}
                  </Typography>
                </Box>
              )}
            </Grid>
            <Grid
              item
              xs={12}
              md={idx % 2 === 0 ? 5 : 7}
              alignItems="center"
              display="flex"
              order={{ xs: idx * 2 + (idx % 2 === 0 ? 0 : 1), md: idx }}
            >
              {idx % 2 === 0 ? (
                <Box>
                  {feature.icon}
                  <Typography variant="h3" color="inherit">
                    {feature.title}
                  </Typography>
                  <Typography variant="body1" color="inherit">
                    {feature.description}
                  </Typography>
                </Box>
              ) : (
                <img src={feature.image} width="100%" alt={feature.imageAlt} />
              )}
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </Container>
  );
}
